var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('main-header'),_c('v-main',{attrs:{"id":"main"}},[_c('div',{attrs:{"id":"contents"}},[_vm._t("default")],2)]),_c('main-footer'),_c('u-scroll-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }